// The production CSP deliberately rejects inline HTML style attributes. Geometry
// is applied through individual CSSOM properties, without weakening that policy.
export function applyHotspotGeometry(stage, asset, bounds, areas) {
  if (!stage || ![bounds?.width, bounds?.height, asset?.width, asset?.height]
    .every(value => Number.isFinite(Number(value)) && Number(value) > 0)) return;
  stage.style.aspectRatio = `${bounds.width} / ${bounds.height}`;
  // The stage is the complete coordinate plane; only its parent scrolls.
  stage.style.width = `${bounds.width}px`;
  stage.style.height = `${bounds.height}px`;
  const viewport = stage.closest?.(".hotspot-viewport");
  if (viewport) {
    viewport.style.width = `${viewport.dataset.width}px`;
    viewport.style.height = `${viewport.dataset.height}px`;
    // Classic desktop scrollbars consume layout space; keep 320×240 (or the
    // selected device size) available for the pixels, not for the scrollbars.
    const gutterX = viewport.offsetWidth - viewport.clientWidth;
    const gutterY = viewport.offsetHeight - viewport.clientHeight;
    if (gutterX > 0) viewport.style.width = `${Number(viewport.dataset.width) + gutterX}px`;
    if (gutterY > 0) viewport.style.height = `${Number(viewport.dataset.height) + gutterY}px`;
  }
  const artwork = stage.querySelector(":scope > img");
  if (artwork) {
    artwork.style.width = `${asset.width / bounds.width * 100}%`;
    artwork.style.height = `${asset.height / bounds.height * 100}%`;
  }
  stage.querySelectorAll("[data-hotspot]").forEach(node => {
    const region = areas[Number(node.dataset.hotspot)]?.region;
    if (!region) return;
    node.style.left = `${region.x / bounds.width * 100}%`;
    node.style.top = `${region.y / bounds.height * 100}%`;
    node.style.width = `${region.width / bounds.width * 100}%`;
    node.style.height = `${region.height / bounds.height * 100}%`;
  });
}
